// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Alert-module__alert--yhc7g{color:#444;word-wrap:break-word;border:1px solid #ddd;border-left:5px solid #09c;border-radius:5px;padding:.75rem;font-size:.75rem;position:relative}.Alert-module__alert--yhc7g.Alert-module__warning--PfkHu{color:#f80;border-left-color:#f80}.Alert-module__alert--yhc7g.Alert-module__error--I0mcN{color:#c00;border-left-color:#c00}.Alert-module__alert--yhc7g .Alert-module__dismiss--ckSEB{color:#999;cursor:pointer;position:absolute;top:50%;right:.75rem;transform:translateY(-50%)}.Alert-module__alert--yhc7g .Alert-module__dismiss--ckSEB:hover{color:#666}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alert": `Alert-module__alert--yhc7g`,
	"warning": `Alert-module__warning--PfkHu`,
	"error": `Alert-module__error--I0mcN`,
	"dismiss": `Alert-module__dismiss--ckSEB`
};
export default ___CSS_LOADER_EXPORT___;
